module.exports = __webpack_public_path__ + "static/media/holidazeScreenshot.1df84c32.jpg";